export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });
};

export const convertDatePickerToDate = (dateObj) => {
  if (!dateObj) return null;
  return new Date(
    dateObj.month + "/" + dateObj.day + "/" + dateObj.year
  );
}; 